<template>
  <div class="shadow-sm tw-rounded-lg" style="height: 400px; width: 100%">
    <div class="tw-flex tw-h-full">
      <div class="tw-w-60 tw-flex-none">
        <div
          class="tw-px-6 tw-pt-4 tw-pb-8 tw-flex tw-flex-col no-select tw-bg-gray-50 tw-rounded-lg"
          style="width: 100%; height: 100%"
        >
          <div
            class="tw-flex tw-items-center tw-cursor-pointer"
            @click="handleClickAllSolution"
          >
            <div class="tw-flex tw-items-center" style="color: #333">
              <img class="tw-w-6 tw-h-6" src="/icon-jjfa.png" alt="" />
              <span class="tw-ml-2 tw-text-xl tw-font-medium">{{
                $t("解决方案")
              }}</span>
            </div>
          </div>
          <div class="tw-flex tw-flex-col tw-mt-5">
            <div class="tw-flex-1">
              <span class="tw-text-sm" style="color: #666">{{
                $t("解决方案介绍")
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="tw-flex tw-flex-col tw-pt-4 tw-pr-4 tw-pl-4 tw-flex-1 hide-scrollbar tw-overflow-y-auto"
      >
        <b-row class="tw-w-full">
          <b-col :cols="12">
            <div class="tw-flex tw-items-center tw-mb-2">
              <div class="tw-cursor-pointer" @click="handleClickAllSolution">
                <span class="tw-text-lg tw-font-medium" style="color: #333">{{
                  $t("解决方案")
                }}</span>
                <!-- <b-icon
                  icon="chevron-right"
                  class="tw-w-4 tw-h-4 tw-ml-1"
                ></b-icon> -->
              </div>
            </div>
          </b-col>
          <b-col
            v-for="(item, index) in solutions"
            cols="4"
            xl="3"
            :key="index"
          >
            <SelectItem
              :item="item"
              @onSelect="handleToDetail"
              :isShowIcon="false"
            />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import { solutionsApi } from "@/api/modules/home";
import SelectItem from "./components/SelectItem.vue";
export default {
  name: "SolutionMenu",
  components: {
    SelectItem,
  },
  data() {
    return {
      navItems: [
        {
          id: 1,
          name: this.$t("解决方案"),
        },
      ],
      activeId: 1,
      listquery: {
        pageIndex: 1,
        pageSize: 12,
      },
      solutions: [],
    };
  },
  mounted() {
    this.getSouList();
  },
  methods: {
    handleClickAllSolution() {
      this.$router.push("/solution");
      this.$emit("handleToDetail", null);
    },
    handleToDetail(item) {
      localStorage.setItem("detailForm", JSON.stringify(item));
      this.$emit("handleToDetail", item);
      this.$router.push(`/solution/${item.id}?id=${item.id}&isApi=false`);
    },
    handleClick(item) {},

    getSouList() {
      solutionsApi(this.listquery).then((res) => {
        if (res && res.data) {
          this.solutions = res.data.list || [];
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-item:hover {
  color: #4077f8;
}

.menu-title-active {
  color: #4077f8;
}

.item-c:hover {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);

  .item-title {
    color: #4077f8 !important;
  }
}
</style>
